// DATA
// button > id / isLast 필수

/**
 * action (next | finish | route | hintView)
 * next: 다음 채팅으로 이동 (onFinish 미사용)
 * finish: 게임 종료 (onFinish 필요)
 * route: 페이지 이동 (onFinish 필요, useNavigate)
 * choice: 버튼이 2개 이상일 경우 'nextData' 데이터가 이어서 표시됨
 */

import introMalang from "../../img/chat/img_intro_malang.png";

import explanationK from "../../img/quiz/img_explanationK.png";
import dreamBridge from "../../img/chat/img_dreambridge.png";

import stage2Img from "../../img/chat/img_quiz2-1.png";
import stage3Img from "../../img/chat/img_quiz3-1.png";

import quiz1Img from "../../img/quiz/img_quiz1-2.png";
import quiz2Img from "../../img/quiz/img_quiz2-2.png";

export const CHAT_DATA = {
  intro1: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk",
      text: `
        안녕, {{playerName}} 요원!<br/>
        나는 미스터리 사건을 해결하는 모다 탐정 사무소의 선임 탐정 ‘꼬네’라고 한다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        최근 키자니아에서 아주 중대한 사건이 발생했다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        전설의 보물 황금 안장이 감쪽같이 사라져버렸다냥!
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        누군가 경비원을 피해 안장을 가져간 흔적이 곳곳에 남아있다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        사라진 보물을 찾기 위해서는 뛰어난 능력을 가진 'AI 비밀요원'의 힘이 필요하다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb40",
      talkType: "chat_b_left_Talk2",
      text: `
        미션에 도전해보겠느냥?
      `,
    },
    {
      type: "chatInfo_Talk1",
      marType: "mb36",
      text: `
        당신은 AI 비밀본부의 수습요원입니다.<br/>
        수습요원 미션을 해결하세요.
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "네, 좋아요!",
      isLast: false,
      action: "next",
    },
    {
      type: "rightCharacter",
      marType: "mb40",
      chat_icon: "Me",
      chat_tit: "{{playerName}}",
      talkType: "chat_b_right_Talk2",
      text: `
        네, 좋아요
      `,
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk",
      text: `
        좋다. 그럼 탐정이 해야 할 일을 설명해 주겠다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        제한 시간 없이 키자니아에 숨겨진 <span class="txtW700">’꿈을 이뤄주는 황금 안장’</span>의 흔적을 찾고 최종 미션에 성공해야 한다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        <span class="txtW700">[게임규칙]</span>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        1. 지금부터 나의 안내에 따라 <span class="txtW700">튜토리얼 퀴즈</span>를 풀어보라냥!
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        2. 튜토리얼 문제를 풀면 메인 미션에 참여할 수 있는 기회가 주어진다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        3. '꿈을 이뤄주는 황금 안장' 미션을 해결하면 리워드를 받을 수 있다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        ...흠흠!
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        오랜만에 인간과 대화하니 들떴다냥. 그럼 함께 사건을 해결하러 출발해보자냥!
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "미션 시작하기",
      isLast: true,
      action: "route",
      route: "/ready",
    },
  ],
  tutorialQuiz1: [
    {
      type: "ImgOnly",
      marType: "mb20",
      className: "chatFullImg",
      src: explanationK,
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk",
      text: `
        갤럭시 AI 비밀요원이 되기 위한 <span class="txtW700">예비 미션</span>이다냥!
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        황금 안장의 흔적을 찾으려면 먼저 '갤럭시 AI 비밀본부' 부스에 도착했는지 확인해야 한다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        아직 갤럭시 AI 비밀본부에 입장을 못했다면 예약부터 하라냥!
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        부스 앞에 도착했다면 간판을 잘 살펴보고 장소 코드를 입력하라냥!
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        AI 비밀본부 요원은 세상의 중요한 정보를 빠르게 해독할 수 있어야 한다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        비밀리에 보내진 단서를 해독해보라냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        <p class="txtW700 txt2EA6B6">[Quiz]</p>
        이 회사는 세계적으로 유명한 전자제품 기업이다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        초성 힌트 : ㅅㅅㅈㅈ
      `,
    },
  ],
  tutorialQuiz1_answer: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk2",
      text: `
        정답이다냥~!
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        정답 : 삼성전자
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        훌륭하다냥! 무사히 AI 비밀본부에 도착했구나냥.
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt16"],
      id: "btn1",
      label: "다음으로",
      isLast: true,
      action: "route",
      route: "/moving",
    },
  ],
  tutorialExp: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk",
      text: `
        본격적인 추적에 앞서 확인할 게 있다냥!
      `,
    },
    {
      type: "left_txt",
      marType: "mb40",
      talkType: "chat_b_left_Talk",
      text: `
        혹시 2층에 있는 <span class="txtW700">'갤럭시 AI 비밀본부'</span> 에서 훈련을 마쳤냥?
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "네, 체험했어요!",
      isLast: true,
      action: "choice",
      nextData: "tutorialExp_yes",
      route: "",
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt16"],
      id: "btn1",
      label: "아니요, 아직 안 했어요!",
      isLast: true,
      action: "choice",
      nextData: "tutorialExp_no",
      route: "",
    },
  ],
  tutorialExp_yes: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk",
      text: `
        훌륭하다냥! 훈련을 마쳤으니 너는 이제 믿음직한 '정식 요원'이다냥!
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        요원증에 배지 스티커를 꼭 붙여달라냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        자, 그럼 혜택이 가득한 특별 미션을 시작해보자냥!
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02"],
      id: "btn1",
      label: "본격적인 미션 도전하기",
      isLast: true,
      action: "route",
      route: "/story2",
      state: {
        DateVal: "story2",
        titImgClass: "story21Tit",
      },
    },
  ],
  tutorialExp_no: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk",
      text: `
        아쉽지만 너는 아직 '수습 요원'이다냥. 하지만 기회를 주겠다냥!
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        이번 사건을 해결하면 요원으로 인정해 주겠다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        다음에는 꼭 비밀본부에도 방문해 보라냥!
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt16"],
      id: "btn1",
      label: "본격적인 미션 도전하기",
      isLast: true,
      action: "route",
      route: "/story2",
      state: {
        DateVal: "story2",
        titImgClass: "story21Tit",
      },
    },
  ],
  story2: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: `
        띠링! ✉️<br/>
        [미션이 도착했습니다.]
      `,
    },
    {
      type: "ImgOnly",
      marType: "mb40",
      className: "chatFullImg",
      src: introMalang,
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Agent",
      chat_tit: "비밀요원 본부장",
      talkType: "chat_b_left_Talk",
      text: `
        흠흠. {{playerName}} 수습요원, 만나서 반갑네. 나는 AI 비밀본부의 본부장이다.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        자네가 튜토리얼 미션을 통과했다는 보고를 받았네<br/>아주 훌륭해.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        자, 이제 자네의 진짜 임무를 줄 시간이지.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        키자니아의 소중한 보물, <span class="txtW700">'꿈을 이뤄주는 황금 안장'</span>이 사라졌네.
      `,
    },
    {
      type: "left_txt",
      marType: "mb24",
      talkType: "chat_b_left_Talk2",
      text: `
        미션 방법을 요약해서 알려주지!
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "황금 안장 찾기 미션 방법 확인하기",
      isLast: false,
      action: "next",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Agent",
      chat_tit: "비밀요원 본부장",
      talkType: "chat_b_left_Talk",
      text: `
        【 빨강 말랑이 미션 방법 】<br/>
        1. 입장할 때 받은 미션 카드를 확인하라!
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        2. 황금안장을 찾았다면, 미션 카드를 활용하여 임무를 수행하라!<br/>
        임무가 무엇인지는 황금안장이 있는 현장에서 확인할 수 있다.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        3. 카드의 우표를 펀칭하고 인증사진과 함께 2층 AI 비밀본부 안내 데스크로 귀환하라!
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        데스크 요원에게 펀칭된 우표를 보여주면 미션완료와 함께 특별한 혜택이 주어질 것이다!
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        그럼, 행운을 빈다!
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt16"],
      id: "btn1",
      label: "황금 안장 찾으러 가기",
      isLast: true,
      action: "route",
      route: "/stage1",
      state: {
        DateVal: "stage1",
      },
    },
  ],
  stage1: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Agent",
      chat_tit: "비밀요원 본부장",
      talkType: "chat_b_left_Talk",
      text: `
        자, 지금부터 ‘꿈을 이뤄주는 황금 안장’의 흔적을 찾아보도록 하지.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        <span class="txtW700">2층에서 아래 말발굽 문양</span>을 찾아 가면 다음 힌트를 얻을 수 있도록 되어 있다.
      `,
    },
    {
      type: "left_txt",
      marType: "mb40",
      talkType: "chat_b_left_Talk2",
      text: `
        바로 찾으러 출발하지!
      `,
    },
    {
      type: "ImgOnly",
      marType: "mb8",
      className: "chatFullImg",
      src: quiz1Img,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "말발굽을 찾았다!",
      isLast: false,
      action: "route",
      route: "/quiz",
      state: {
        answerData: "quiz1",
        DateVal: "quiz1",
        titImgClass: "quizTit",
        hintWhetherIs: true,
        hintContent: "2",
      },
    },
  ],
  quiz1: [
    {
      type: "ImgOnly",
      marType: "mb24",
      className: "chatFullImg",
      src: quiz1Img,
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Agent",
      chat_tit: "비밀요원 본부장",
      talkType: "chat_b_left_Talk2",
      text: `
        말발굽에는 어떤 큰 문양이 그려져 있다.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        <p class="txtW700 txt2EA6B6">[Quiz]</p>
        [?]에 맞는 말발굽 문양이 무엇인지 알맞은 모양을 골라서 숫자를 입력하라.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        1. ●<br/>
        2. ★<br/>
        3. ■<br/>
        4. ▲
      `,
    },
  ],
  quiz1_answer: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Agent",
      chat_tit: "비밀요원 본부장",
      talkType: "chat_b_left_Talk2",
      text: `
        정답이다!
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        정답: 2 ★
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02"],
      id: "btn1",
      label: "다음으로",
      isLast: true,
      action: "route",
      route: "/stage2",
    },
  ],
  stage2: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Agent",
      chat_tit: "비밀요원 본부장",
      talkType: "chat_b_left_Talk2",
      text: `
        ‘꿈을 이뤄주는 황금 안장’의 다음 흔적을 찾았다.
      `,
    },
    {
      type: "left_txt",
      marType: "mb40",
      talkType: "chat_b_left_Talk",
      text: `
        아래 사진의 장소로 이동해 미션을 해결하라.
      `,
    },
    {
      type: "ImgOnly",
      marType: "mb40",
      className: "chatFullImg",
      src: stage2Img,
    },
    {
      type: "button",
      classes: ["inputBtn02"],
      id: "btn1",
      label: "이동 완료!",
      isLast: false,
      action: "route",
      route: "/quiz",
      state: {
        answerData: "quiz2",
        DateVal: "quiz2",
        titImgClass: "quizTit",
        hintWhetherIs: true,
        hintContent: "3",
      },
    },
  ],
  quiz2: [
    {
      type: "ImgOnly",
      marType: "mb24",
      className: "chatFullImg",
      src: quiz2Img,
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Agent",
      chat_tit: "비밀요원 본부장",
      talkType: "chat_b_left_Talk2",
      text: `
        ‘꿈을 이뤄주는 황금 안장’을 빨강 말랑이가 이곳으로 옮겨 놓았다.<br/>
        이유는 무엇일까?
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        <p class="txtW700 txt2EA6B6">[Quiz]</p>
        사진 속 하얀 네모에 쓰여진 글자는?<br/>
        아래 보기를 보고 숫자를 입력하라.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        1. Cream<br/>
        2. Bird<br/>
        3. Dream<br/>
        4. Art
      `,
    },
  ],
  quiz2_answer: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Agent",
      chat_tit: "비밀요원 본부장",
      talkType: "chat_b_left_Talk2",
      text: `
        정답이다!
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        정답: 3. Dream
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02"],
      id: "btn1",
      label: "다음으로",
      isLast: true,
      action: "route",
      route: "/stage3",
    },
  ],
  stage3: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Agent",
      chat_tit: "비밀요원 본부장",
      talkType: "chat_b_left_Talk2",
      text: `
        ‘꿈을 이뤄주는 황금 안장’의 다음 흔적을 찾았다.
      `,
    },
    {
      type: "left_txt",
      marType: "mb40",
      talkType: "chat_b_left_Talk",
      text: `
        3층으로 올라가 아래 사진이 있는 곳으로 이동하라.
      `,
    },
    {
      type: "ImgOnly",
      marType: "mb40",
      className: "chatFullImg",
      src: stage3Img,
    },
    {
      type: "button",
      classes: ["inputBtn02"],
      id: "btn1",
      label: "이동 완료!",
      isLast: false,
      action: "route",
      route: "/quiz",
      state: {
        answerData: "quiz3",
        DateVal: "quiz3",
        titImgClass: "quizTit",
        hintWhetherIs: true,
        hintContent: "4",
      },
    },
  ],
  quiz3: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Agent",
      chat_tit: "비밀요원 본부장",
      talkType: "chat_b_left_Talk",
      text: `
        ‘꿈을 이뤄주는 황금 안장’이 어느 동물 위에 있다.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        <p class="txtW700 txt2EA6B6">[Quiz]</p>
        황금 안장이 어느 동물 위에 있는지, 동물의 색깔은 무엇인지 확인하고 <br/>
        아래 보기를 보고 숫자를 입력하라.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        1. 파랑색 / 사자<br/>
        2. 흰색 / 코끼리<br/>
        3. 검정색 / 새<br/>
        4. 빨강색 / 말
      `,
    },
  ],
  quiz3_answer: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Agent",
      chat_tit: "비밀요원 본부장",
      talkType: "chat_b_left_Talk2",
      text: `
        정답이다!
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        정답: 4. 빨강색 / 말
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02"],
      id: "btn1",
      label: "다음으로",
      isLast: true,
      action: "route",
      route: "/writeDream",
      state: {
        DateVal: "write_dream",
      },
    },
  ],
  write_dream: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Agent",
      chat_tit: "비밀요원 본부장",
      talkType: "chat_b_left_Talk",
      text: `
        ‘꿈을 이뤄주는 황금 안장’을 빨강 말랑이가 이곳 <span class="txtW700">드림브리지로 가져온 이유</span>를 드디어 알아냈다.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        드림브리지는 어린이의 꿈을 응원하는 특별한 다리이기 때문이지.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        빨강 말랑이는 아이들의 꿈을 이뤄주는 황금 안장이 이곳에 있어야
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        우리 요원님들의 소중한 꿈을 가장 잘 지켜줄 수 있을 거라고 생각했던 것 같다.
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02"],
      id: "btn1",
      label: "다음으로",
      isLast: true,
      action: "route",
      route: "/take_picture",
      state: {
        DateVal: "take_picture",
      },
    },
  ],
  take_picture: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Agent",
      chat_tit: "비밀요원 본부장",
      talkType: "chat_b_left_Talk",
      text: `
        자, 이제 3층 드림브리지에서 황금 안장을 입은 <span class="txtW700">빨강 말랑이와 함께 멋진 인증 사진</span>을 찰칵 찍어보게.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        사진을 찍은 후, 미션 카드에 <span class="txtW700">우표 모양 펀칭기로 우표 모양을 찍고</span>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        <span class="txtW700">2층 '갤럭시 AI 비밀본부' 인증처</span>로 씩씩하게 돌아가 인증처 요원에게 보여주면
      `,
    },
    {
      type: "left_txt",
      marType: "mb40",
      talkType: "chat_b_left_Talk",
      text: `
        특별한 임무 완료 보상을 받을 수 있다네!
      `,
    },
    {
      type: "chatInfo_Talk1",
      marType: "mb8",
      text: `
        [최종 미션]<br/>
        1. 미션 카드에 우표 모양 펀칭기로 우표 모양 찍기<br/>
        2. 2층 갤럭시 AI 비밀본부 인증처로 이동 후 보상 받기<br/><br/>
        [특별 보상 획득]<br/>
        갤럭시 AI 비밀본부 체험 후 비밀 미션을 성공하라.
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02"],
      id: "btn1",
      label: "다음으로",
      isLast: true,
      action: "route",
      route: "/clear",
    },
  ],
};
